import { ROUTER_PATH } from "@/src/config/router";

/** Detail 预热轻壳 seed（无 ROUTER_PATH 常量，与原生 DetailWebViewSlot 对齐） */
export const APP_DETAIL_SHELL_PATH = "/app-detail-shell";

/**
 * App 辅助 WebView seed：Chat modal / Detail 预热轻壳。
 * Proxy 307 与客户端未登录门禁、EntryGate 共用，避免主壳外的 WebView 被拉到 /login 或 /brief。
 */
export function isAppAuxiliaryShellRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.APP_CHAT_MODAL ||
    pathname.startsWith(`${ROUTER_PATH.APP_CHAT_MODAL}/`) ||
    pathname === APP_DETAIL_SHELL_PATH ||
    pathname.startsWith(`${APP_DETAIL_SHELL_PATH}/`)
  );
}
